
// @ts-nocheck


export const localeCodes =  [
  "ru",
  "en",
  "es",
  "fr",
  "de",
  "it",
  "pt",
  "zh",
  "bg",
  "tr",
  "ja",
  "ua",
  "th",
  "hi",
  "be",
  "pl",
  "ar",
  "bn",
  "ko",
  "sw",
  "vi",
  "id",
  "da",
  "et",
  "hu",
  "lt",
  "nb",
  "ro",
  "sl",
  "cs",
  "el",
  "fi",
  "lv",
  "nl",
  "sk",
  "sv",
  "he"
]

export const localeLoaders = {
  ru: [
    {
      key: "locale_ru_46json_3e73ac9e",
      load: () => import("#nuxt-i18n/3e73ac9e" /* webpackChunkName: "locale_ru_46json_3e73ac9e" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_9b86ed3e",
      load: () => import("#nuxt-i18n/9b86ed3e" /* webpackChunkName: "locale_en_46json_9b86ed3e" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_42d8bf82",
      load: () => import("#nuxt-i18n/42d8bf82" /* webpackChunkName: "locale_es_46json_42d8bf82" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_e85276e2",
      load: () => import("#nuxt-i18n/e85276e2" /* webpackChunkName: "locale_fr_46json_e85276e2" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_ad7861b7",
      load: () => import("#nuxt-i18n/ad7861b7" /* webpackChunkName: "locale_de_46json_ad7861b7" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_6d54ed91",
      load: () => import("#nuxt-i18n/6d54ed91" /* webpackChunkName: "locale_it_46json_6d54ed91" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_5f2eade5",
      load: () => import("#nuxt-i18n/5f2eade5" /* webpackChunkName: "locale_pt_46json_5f2eade5" */),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_46json_6b8c9a0b",
      load: () => import("#nuxt-i18n/6b8c9a0b" /* webpackChunkName: "locale_zh_46json_6b8c9a0b" */),
      cache: true
    }
  ],
  bg: [
    {
      key: "locale_bg_46json_46cb4f7e",
      load: () => import("#nuxt-i18n/46cb4f7e" /* webpackChunkName: "locale_bg_46json_46cb4f7e" */),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_46json_7fbce1b5",
      load: () => import("#nuxt-i18n/7fbce1b5" /* webpackChunkName: "locale_tr_46json_7fbce1b5" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_64fb060a",
      load: () => import("#nuxt-i18n/64fb060a" /* webpackChunkName: "locale_ja_46json_64fb060a" */),
      cache: true
    }
  ],
  ua: [
    {
      key: "locale_ua_46json_4d939b35",
      load: () => import("#nuxt-i18n/4d939b35" /* webpackChunkName: "locale_ua_46json_4d939b35" */),
      cache: true
    }
  ],
  th: [
    {
      key: "locale_th_46json_037b2e07",
      load: () => import("#nuxt-i18n/037b2e07" /* webpackChunkName: "locale_th_46json_037b2e07" */),
      cache: true
    }
  ],
  hi: [
    {
      key: "locale_hi_46json_2412a7da",
      load: () => import("#nuxt-i18n/2412a7da" /* webpackChunkName: "locale_hi_46json_2412a7da" */),
      cache: true
    }
  ],
  be: [
    {
      key: "locale_be_46json_dee4e653",
      load: () => import("#nuxt-i18n/dee4e653" /* webpackChunkName: "locale_be_46json_dee4e653" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_63a45e89",
      load: () => import("#nuxt-i18n/63a45e89" /* webpackChunkName: "locale_pl_46json_63a45e89" */),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_ar_46json_431ad415",
      load: () => import("#nuxt-i18n/431ad415" /* webpackChunkName: "locale_ar_46json_431ad415" */),
      cache: true
    }
  ],
  bn: [
    {
      key: "locale_bn_46json_2c430b80",
      load: () => import("#nuxt-i18n/2c430b80" /* webpackChunkName: "locale_bn_46json_2c430b80" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_655e1be0",
      load: () => import("#nuxt-i18n/655e1be0" /* webpackChunkName: "locale_ko_46json_655e1be0" */),
      cache: true
    }
  ],
  sw: [
    {
      key: "locale_sw_46json_804b7726",
      load: () => import("#nuxt-i18n/804b7726" /* webpackChunkName: "locale_sw_46json_804b7726" */),
      cache: true
    }
  ],
  vi: [
    {
      key: "locale_vi_46json_6e0c4341",
      load: () => import("#nuxt-i18n/6e0c4341" /* webpackChunkName: "locale_vi_46json_6e0c4341" */),
      cache: true
    }
  ],
  id: [
    {
      key: "locale_id_46json_9c30cb40",
      load: () => import("#nuxt-i18n/9c30cb40" /* webpackChunkName: "locale_id_46json_9c30cb40" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_a6d2adc2",
      load: () => import("#nuxt-i18n/a6d2adc2" /* webpackChunkName: "locale_da_46json_a6d2adc2" */),
      cache: true
    }
  ],
  et: [
    {
      key: "locale_et_46json_41826f78",
      load: () => import("#nuxt-i18n/41826f78" /* webpackChunkName: "locale_et_46json_41826f78" */),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_46json_9108e353",
      load: () => import("#nuxt-i18n/9108e353" /* webpackChunkName: "locale_hu_46json_9108e353" */),
      cache: true
    }
  ],
  lt: [
    {
      key: "locale_lt_46json_497e9ebb",
      load: () => import("#nuxt-i18n/497e9ebb" /* webpackChunkName: "locale_lt_46json_497e9ebb" */),
      cache: true
    }
  ],
  nb: [
    {
      key: "locale_nb_46json_6aab2ded",
      load: () => import("#nuxt-i18n/6aab2ded" /* webpackChunkName: "locale_nb_46json_6aab2ded" */),
      cache: true
    }
  ],
  ro: [
    {
      key: "locale_ro_46json_827fec29",
      load: () => import("#nuxt-i18n/827fec29" /* webpackChunkName: "locale_ro_46json_827fec29" */),
      cache: true
    }
  ],
  sl: [
    {
      key: "locale_sl_46json_77548f79",
      load: () => import("#nuxt-i18n/77548f79" /* webpackChunkName: "locale_sl_46json_77548f79" */),
      cache: true
    }
  ],
  cs: [
    {
      key: "locale_cs_46json_ef3f4a35",
      load: () => import("#nuxt-i18n/ef3f4a35" /* webpackChunkName: "locale_cs_46json_ef3f4a35" */),
      cache: true
    }
  ],
  el: [
    {
      key: "locale_el_46json_ff26fed6",
      load: () => import("#nuxt-i18n/ff26fed6" /* webpackChunkName: "locale_el_46json_ff26fed6" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_48c2e417",
      load: () => import("#nuxt-i18n/48c2e417" /* webpackChunkName: "locale_fi_46json_48c2e417" */),
      cache: true
    }
  ],
  lv: [
    {
      key: "locale_lv_46json_277dfd79",
      load: () => import("#nuxt-i18n/277dfd79" /* webpackChunkName: "locale_lv_46json_277dfd79" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_8539d659",
      load: () => import("#nuxt-i18n/8539d659" /* webpackChunkName: "locale_nl_46json_8539d659" */),
      cache: true
    }
  ],
  sk: [
    {
      key: "locale_sk_46json_62a2235c",
      load: () => import("#nuxt-i18n/62a2235c" /* webpackChunkName: "locale_sk_46json_62a2235c" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_66e768eb",
      load: () => import("#nuxt-i18n/66e768eb" /* webpackChunkName: "locale_sv_46json_66e768eb" */),
      cache: true
    }
  ],
  he: [
    {
      key: "locale_he_46json_8fd986d3",
      load: () => import("#nuxt-i18n/8fd986d3" /* webpackChunkName: "locale_he_46json_8fd986d3" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "ru",
      iso: "ru-RU",
      language: "ru-RU",
      name: "Русский",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/ru.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      iso: "en-US",
      language: "en-US",
      name: "English",
      dir: "ltr",
      isCatchallLocale: true,
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      iso: "es-ES",
      language: "es-ES",
      name: "Español",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      iso: "fr-FR",
      language: "fr-FR",
      name: "Francés",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      iso: "de-DE",
      language: "de-DE",
      name: "Deutsch",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      iso: "it-IT",
      language: "it-IT",
      name: "Italiano",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      iso: "pt-PT",
      language: "pt-PT",
      name: "Português",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/pt.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      iso: "zh-CN",
      language: "zh-CN",
      name: "中文",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/zh.json",
          cache: undefined
        }
      ]
    },
    {
      code: "bg",
      iso: "bg-BG",
      language: "bg-BG",
      name: "Български",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/bg.json",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      iso: "tr-TR",
      language: "tr-TR",
      name: "Türkçe",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/tr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ja",
      iso: "ja-JP",
      language: "ja-JP",
      name: "日本語",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/ja.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ua",
      iso: "ua-UA",
      language: "ua-UA",
      name: "Українська",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/ua.json",
          cache: undefined
        }
      ]
    },
    {
      code: "th",
      iso: "th-TH",
      language: "th-TH",
      name: "ไทย",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/th.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hi",
      iso: "hi-IN",
      language: "hi-IN",
      name: "भारतीय",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/hi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "be",
      iso: "be-BY",
      language: "be-BY",
      name: "Беларуская",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/be.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      iso: "pl-PL",
      language: "pl-PL",
      name: "Polski",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/pl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ar",
      iso: "ar-SA",
      language: "ar-SA",
      name: "عربي",
      dir: "rtl",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/ar.json",
          cache: undefined
        }
      ]
    },
    {
      code: "bn",
      iso: "bn-IN",
      language: "bn-IN",
      name: "বাংলা",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/bn.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ko",
      iso: "ko-KR",
      language: "ko-KR",
      name: "한국인",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/ko.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sw",
      iso: "sw-TZ",
      language: "sw-TZ",
      name: "Kiswahili",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/sw.json",
          cache: undefined
        }
      ]
    },
    {
      code: "vi",
      iso: "vi-VN",
      language: "vi-VN",
      name: "Tiếng Việt",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/vi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "id",
      iso: "id-ID",
      language: "id-ID",
      name: "Bahasa Indonesia",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/id.json",
          cache: undefined
        }
      ]
    },
    {
      code: "da",
      iso: "da-DK",
      language: "da-DK",
      name: "Dansk",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/da.json",
          cache: undefined
        }
      ]
    },
    {
      code: "et",
      iso: "et-EE",
      language: "et-EE",
      name: "Eesti",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/et.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hu",
      iso: "hu-HU",
      language: "hu-HU",
      name: "Magyar",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/hu.json",
          cache: undefined
        }
      ]
    },
    {
      code: "lt",
      iso: "lt-LT",
      language: "lt-LT",
      name: "Lietuvių",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/lt.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nb",
      iso: "nb-NO",
      language: "nb-NO",
      name: "Norsk bokmål",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/nb.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ro",
      iso: "ro-RO",
      language: "ro-RO",
      name: "Română",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/ro.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sl",
      iso: "sl-SI",
      language: "sl-SI",
      name: "Slovenščina",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/sl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "cs",
      iso: "cs-CZ",
      language: "cs-CZ",
      name: "Čeština",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/cs.json",
          cache: undefined
        }
      ]
    },
    {
      code: "el",
      iso: "el-GR",
      language: "el-GR",
      name: "Ελληνικά",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/el.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fi",
      iso: "fi-FI",
      language: "fi-FI",
      name: "Suomi",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/fi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "lv",
      iso: "lv-LV",
      language: "lv-LV",
      name: "Latviešu",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/lv.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      iso: "nl-NL",
      language: "nl-NL",
      name: "Nederlands",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sk",
      iso: "sk-SK",
      language: "sk-SK",
      name: "Slovenčina",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/sk.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sv",
      iso: "sv-SE",
      language: "sv-SE",
      name: "Svenska",
      dir: "ltr",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/sv.json",
          cache: undefined
        }
      ]
    },
    {
      code: "he",
      iso: "he-IL",
      language: "he-IL",
      name: "עברית",
      dir: "rtl",
      files: [
        {
          path: "/home/server/builds/landing-2025-04-22-14-33/locales/he.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "../locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://pst.net",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "ru",
    iso: "ru-RU",
    language: "ru-RU",
    name: "Русский",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/ru.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    iso: "en-US",
    language: "en-US",
    name: "English",
    dir: "ltr",
    isCatchallLocale: true,
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    iso: "es-ES",
    language: "es-ES",
    name: "Español",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    iso: "fr-FR",
    language: "fr-FR",
    name: "Francés",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    iso: "de-DE",
    language: "de-DE",
    name: "Deutsch",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    iso: "it-IT",
    language: "it-IT",
    name: "Italiano",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    iso: "pt-PT",
    language: "pt-PT",
    name: "Português",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/pt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    iso: "zh-CN",
    language: "zh-CN",
    name: "中文",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/zh.json",
        cache: undefined
      }
    ]
  },
  {
    code: "bg",
    iso: "bg-BG",
    language: "bg-BG",
    name: "Български",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/bg.json",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    iso: "tr-TR",
    language: "tr-TR",
    name: "Türkçe",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/tr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    iso: "ja-JP",
    language: "ja-JP",
    name: "日本語",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/ja.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ua",
    iso: "ua-UA",
    language: "ua-UA",
    name: "Українська",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/ua.json",
        cache: undefined
      }
    ]
  },
  {
    code: "th",
    iso: "th-TH",
    language: "th-TH",
    name: "ไทย",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/th.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hi",
    iso: "hi-IN",
    language: "hi-IN",
    name: "भारतीय",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/hi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "be",
    iso: "be-BY",
    language: "be-BY",
    name: "Беларуская",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/be.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    iso: "pl-PL",
    language: "pl-PL",
    name: "Polski",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/pl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    iso: "ar-SA",
    language: "ar-SA",
    name: "عربي",
    dir: "rtl",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/ar.json",
        cache: undefined
      }
    ]
  },
  {
    code: "bn",
    iso: "bn-IN",
    language: "bn-IN",
    name: "বাংলা",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/bn.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    iso: "ko-KR",
    language: "ko-KR",
    name: "한국인",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/ko.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sw",
    iso: "sw-TZ",
    language: "sw-TZ",
    name: "Kiswahili",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/sw.json",
        cache: undefined
      }
    ]
  },
  {
    code: "vi",
    iso: "vi-VN",
    language: "vi-VN",
    name: "Tiếng Việt",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/vi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "id",
    iso: "id-ID",
    language: "id-ID",
    name: "Bahasa Indonesia",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/id.json",
        cache: undefined
      }
    ]
  },
  {
    code: "da",
    iso: "da-DK",
    language: "da-DK",
    name: "Dansk",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/da.json",
        cache: undefined
      }
    ]
  },
  {
    code: "et",
    iso: "et-EE",
    language: "et-EE",
    name: "Eesti",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/et.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hu",
    iso: "hu-HU",
    language: "hu-HU",
    name: "Magyar",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/hu.json",
        cache: undefined
      }
    ]
  },
  {
    code: "lt",
    iso: "lt-LT",
    language: "lt-LT",
    name: "Lietuvių",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/lt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nb",
    iso: "nb-NO",
    language: "nb-NO",
    name: "Norsk bokmål",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/nb.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ro",
    iso: "ro-RO",
    language: "ro-RO",
    name: "Română",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/ro.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sl",
    iso: "sl-SI",
    language: "sl-SI",
    name: "Slovenščina",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/sl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "cs",
    iso: "cs-CZ",
    language: "cs-CZ",
    name: "Čeština",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/cs.json",
        cache: undefined
      }
    ]
  },
  {
    code: "el",
    iso: "el-GR",
    language: "el-GR",
    name: "Ελληνικά",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/el.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fi",
    iso: "fi-FI",
    language: "fi-FI",
    name: "Suomi",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/fi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "lv",
    iso: "lv-LV",
    language: "lv-LV",
    name: "Latviešu",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/lv.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    iso: "nl-NL",
    language: "nl-NL",
    name: "Nederlands",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sk",
    iso: "sk-SK",
    language: "sk-SK",
    name: "Slovenčina",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/sk.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    iso: "sv-SE",
    language: "sv-SE",
    name: "Svenska",
    dir: "ltr",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/sv.json",
        cache: undefined
      }
    ]
  },
  {
    code: "he",
    iso: "he-IL",
    language: "he-IL",
    name: "עברית",
    dir: "rtl",
    files: [
      {
        path: "/home/server/builds/landing-2025-04-22-14-33/locales/he.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/